module.exports = __webpack_public_path__ + "img/3029011-76-2.26fd6a4b.png";